import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, CheckCircle2, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, formatErr, previewUrl } from "@/lib/api";

const HdItem = ({ item, onSent }) => {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const send = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      await api.post(`/photos/${item.photo_id}/hd`, fd, { timeout: 180000 });
      toast.success("File HD terkirim");
      onSent(item.photo_id);
    } catch (e) {
      toast.error(formatErr(e));
    } finally {
      setBusy(false);
      ref.current.value = "";
    }
  };
  return (
    <li className="flex items-center gap-3 py-2" data-testid={`hd-item-${item.photo_id}`}>
      <img src={previewUrl(item.photo_id)} alt="" className="h-12 w-16 rounded-lg object-cover bg-zinc-100" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium truncate">{item.filename || item.photo_id}</p>
        {item.hd_ready
          ? <p className="text-xs text-emerald-700"><CheckCircle2 className="inline h-3 w-3 mr-1" />HD terkirim</p>
          : <p className="text-xs text-amber-700"><Clock className="inline h-3 w-3 mr-1" />Menunggu file HD</p>}
      </div>
      <Button size="sm" variant={item.hd_ready ? "outline" : "default"} disabled={busy} onClick={() => ref.current.click()}
        className={`rounded-lg ${item.hd_ready ? "" : "bg-emerald-600 hover:bg-emerald-700"}`} data-testid={`hd-item-upload-${item.photo_id}`}>
        <Upload className="h-3.5 w-3.5 mr-1" />{busy ? "..." : item.hd_ready ? "Ganti" : "Unggah HD"}
      </Button>
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={(e) => send(e.target.files[0])} data-testid={`hd-item-input-${item.photo_id}`} />
    </li>
  );
};

export const HdDeliveryDialog = ({ order, onClose, onSent }) => (
  <Dialog open={!!order} onOpenChange={(v) => !v && onClose()}>
    <DialogContent className="rounded-2xl max-w-xl" aria-describedby={undefined} data-testid="hd-dialog">
      <DialogHeader><DialogTitle>Kirim file HD · {order?.code}</DialogTitle></DialogHeader>
      <p className="text-sm text-zinc-500">Unggah file resolusi penuh untuk setiap foto. Pembeli mendapat email dan bisa langsung mengunduhnya. Untuk banyak foto sekaligus, gunakan "Kirim file HD" di halaman event (dicocokkan otomatis dari nama file).</p>
      <ul className="divide-y divide-zinc-100 max-h-[55vh] overflow-y-auto">
        {order?.items.map((i) => <HdItem key={i.photo_id} item={i} onSent={onSent} />)}
      </ul>
    </DialogContent>
  </Dialog>
);
